const decadeYears = (decadeItems) => {
  let decadeYearsHtml = '';

  decadeItems.forEach((decadeItem) => {
    decadeYearsHtml += `<li class="events__year -phase-${decadeItem.phase.id} -${decadeItem.phase.color}" data-region="eventsYear" data-index="${decadeItem.index}">
      <span class="class="events__year-info">${decadeItem.startYear}</span>
    </li>`;
  });

  return decadeYearsHtml;
};

const decadeItem = ({ decade, decadeItems }) => `
  <li class="decades__decade -phase-${decadeItems[0].phase.id} -${decadeItems[0].phase.color}" data-region="timelineDecade">
    <span class="decades__decade-toggle" data-region="decadeToggle"></span>
    <span class="decades__decade-year">${decade}</span>
    <ul class="events">${decadeYears(decadeItems)}</ul>
  </li>
`;

const eventSlide = ({ index, eventItem }) => `
  <div class="timeline__events-event -phase-${eventItem.phase.id} -${eventItem.phase.color}" data-region="timelineEvent" data-index="${index}">
    <div class="timeline__events-event-image">
      <img src="${eventItem.image.url}" alt="${eventItem.image.alt}" />
    </div>
    <div class="timeline__events-event-details">
      <h2>${eventItem.displayYear}</h2>
      <p>${eventItem.description}</p>
    </div>
  </div>
`;

export { decadeItem, eventSlide };
